import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Camp dates
export const CAMP_START = new Date(2026, 5, 29); // June 29, 2026
export const CAMP_END = new Date(2026, 7, 20); // August 20, 2026
export const FRIDAY_START = new Date(2026, 6, 10); // July 10, 2026
export const FRIDAY_END = new Date(2026, 7, 14); // August 14, 2026
export const SATURDAY_DATES = [
  "06/27/2026", "07/11/2026", "07/18/2026", "07/25/2026",
  "08/01/2026", "08/08/2026", "08/15/2026"
];
export const SKIP_DATES = [
  new Date(2026, 6, 3).toDateString(), // July 3
  new Date(2026, 6, 4).toDateString(), // July 4
];

export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
export const TIMES = ["8:30am", "4:00pm", "4:30pm"];
export const SATURDAY_TIMES = ["9:00am", "9:30am", "10:00am"];
export const ALL_TIMES = ["8:30am", "9:00am", "9:30am", "10:00am", "4:00pm", "4:30pm"];

export function getTimesForDayType(day) {
  if (!day) return TIMES;
  return day.toLowerCase() === "saturday" ? SATURDAY_TIMES : TIMES;
}

export const PRICE_MTH = 360; // Mon-Thu (8 weeks)
export const PRICE_FRI = 270; // Friday (6 weeks)
export const PRICE_SAT = 315; // Saturday (7 weeks)

export function calculateLessonDates(day, isFridayDay = false) {
  if (day.toLowerCase() === "saturday") {
    return SATURDAY_DATES.map(d => {
      const [m, dd, y] = d.split("/");
      return new Date(parseInt(y), parseInt(m) - 1, parseInt(dd));
    });
  }

  const dates = [];
  const dayIndex = DAYS.indexOf(day.toLowerCase());
  if (dayIndex === -1) return dates;

  const start = isFridayDay ? FRIDAY_START : CAMP_START;
  const end = isFridayDay ? FRIDAY_END : CAMP_END;
  
  let current = new Date(start);
  while (current <= end) {
    if (current.getDay() === dayIndex + 1 && !SKIP_DATES.includes(current.toDateString())) {
      dates.push(new Date(current));
    }
    current.setDate(current.getDate() + 1);
  }
  
  return dates;
}

export function formatDate(date) {
  return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
}

export function isFriday(day) {
  return day.toLowerCase() === "friday";
}

export function isSaturday(day) {
  return day.toLowerCase() === "saturday";
}

export function getPrice(day) {
  if (isSaturday(day)) return PRICE_SAT;
  if (isFriday(day)) return PRICE_FRI;
  return PRICE_MTH;
}

export function getWeeks(day) {
  if (isSaturday(day)) return "7 weeks";
  if (isFriday(day)) return "6 weeks";
  return "8 weeks";
}
